import { ChevronDown } from 'lucide-react';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { trackFAQExpand } from '@/lib/analytics';

export default function FAQSection({ faqItems }) {
  const { t } = useTranslation();
  if (!faqItems || faqItems.length === 0) return null;

  return (
    <div className="border border-slate-800/50 rounded-xl p-5 mb-6" data-testid="faq-section">
      <h3 className="text-sm font-semibold text-slate-300 uppercase tracking-wider mb-4"
        style={{ fontFamily: 'var(--font-heading)' }}>
        {t('seo.faq', 'FAQ')}
      </h3>
      <div className="space-y-2">
        {faqItems.map((item, i) => (
          <FAQItem key={i} question={item.question} answer={item.answer} index={i} />
        ))}
      </div>
    </div>
  );
}

function FAQItem({ question, answer, index }) {
  const [open, setOpen] = useState(false);
  return (
    <div className="border border-slate-800/30 rounded-lg overflow-hidden" data-testid={`faq-item-${index}`}>
      <button onClick={() => { if (!open) trackFAQExpand(question); setOpen(!open); }}
        className="w-full flex items-center justify-between px-4 py-3 text-left hover:bg-slate-800/30 transition-colors">
        <span className="text-sm text-slate-300 font-medium pr-4">{question}</span>
        <ChevronDown className={`w-4 h-4 text-slate-500 shrink-0 transition-transform ${open ? 'rotate-180' : ''}`} />
      </button>
      {open && (
        <div className="px-4 pb-3">
          <p className="text-xs text-slate-400 leading-relaxed">{answer}</p>
        </div>
      )}
    </div>
  );
}
